import { Node } from 'utils/Tree'
import { WorkawareBaseClass } from './WorkawareBaseClass'

export class WorkawareBaseNodeClass extends WorkawareBaseClass implements Node {
  _className = 'WorkawareBaseNodeClass'
  public Id: number | undefined = undefined
  public parent: Node | undefined = undefined
  public children: Node[] = []
}
